<template>
  <v-card flat>
    <h1>{{ $t('application.documents.title') }}</h1>

    <!-- GUG-RESULTAT -->
  <template v-if="gugCourses && gugCourses.length > 0">
    <h4 class="mt-n1">{{ $t('application.documents.gug-info') }}</h4>
    <p class="mt-5">{{ $t('application.documents.gug-p') }}</p>

    <div class="mb-6">
      <h4 class="mt-6">{{ $t('application.documents.gug-list-title') }}</h4>
      <v-card flat>
        <v-list two-line class="height-small">
          <template v-for="(item, index) in gugCourses">
            <v-list-item :key="index" class="pl-0">
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 bold"> {{ item.courseName }}</v-list-item-title>
                <v-list-item-subtitle class="body-2"
                  >{{ item.credit ? item.credit : '' }}p, {{ item.courseCode ? item.courseCode : '' }} ({{
                    item.schoolName ? item.schoolName : 'Utbildningsgivare ej angiven'
                  }})
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`divider-${index}`" v-if="index + 1 < gugCourses.length"></v-divider>
          </template>
        </v-list>
      </v-card>
    </div>
  </template>

    <h4>{{ $t('application.documents.info1') }}</h4>

    <p class="mt-5">{{ $t('application.documents.info3') }}</p>

    <div v-if="!showDocuments" class="mt-7">
      <ActionButton @click="showDocuments = true" type="application" actionIcon="$sl-attachment">{{
        $t('labels.show-upload-certificate')
      }}</ActionButton>
    </div>
    <div v-if="showDocuments">
      <p>{{ $t('application.documents.doc-p1') }}</p>
      <p>{{ $t('application.documents.doc-p2') }}</p>

      <MessageBox class="my-5" type="info">
        <h6>{{ $t('application.documents.infoBox1-title') }}</h6>
        <p>{{ $t('application.documents.infoBox1') }}</p>
      </MessageBox>

      <FileUpload :files="selectedGUGCerts" :fileType="3">
        <h4 class="mt-10">{{ $t('application.documents.gug-certificate') }}</h4>
        <p class="mb-8 mt-n1">{{ $t('application.documents.gug-certificate-p') }}</p>
      </FileUpload>

      <FileUpload :files="selectedFiles" :fileType="2">
        <h4 class="mt-10">{{ $t('application.documents.certificate') }}</h4>
        <p class="mb-8 mt-n1">{{ $t('application.documents.certificate-p') }}</p>
        <p>{{ $t('application.documents.certificate-ul') }}</p>
        <ul class="mt-n2">
          <li>
            <p>{{ $t('application.documents.certificate-ul-li1') }}</p>
          </li>
          <li class="mt-n4">
            <p>{{ $t('application.documents.certificate-ul-li2') }}</p>
          </li>
        </ul>
      </FileUpload>

      <FileUpload :files="selectedGrades" :fileType="1">
        <h4>{{ $t('application.documents.grades-document') }}</h4>
        <p class="mb-8 mt-n1">{{ $t('application.documents.grades-document-p') }} <strong>{{ $t('application.documents.grades-document-p2') }}</strong> </p>
      </FileUpload>
      <template v-if="!!selectedGrades.length">
        <ApplicationDocumentSchool ref="form" v-model="schoolId"  :anotherSchool.sync="anotherSchool"/>
      </template>
    </div>
    <div v-if="nextStepDisabled">
      <h6 class="mb-1 mt-8 error--text">{{ $t('application.documents.grades-document-disabled') }}</h6>
    </div>
    <NextButton color="yellow" class="mr-4" @click="nextStep" :is-disabled="nextStepDisabled">
      {{ $t('tour.next') }}
    </NextButton>

    <div v-if="selectedApplication && selectedApplication.isCompanyApplication">
      <BottomNav @clicked="$emit('goToStep', '-3')" />
    </div>
    <div v-else>
      <BottomNav
        @clicked="
          $emit(
            'goToStep',
            selectedApplication &&
              selectedApplication.professionId &&
              hasProfessionOrientations(selectedApplication.professionId)
              ? '-1'
              : '-2'
          )
        "
      />
    </div>

  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import filter from 'lodash/filter'
import {RulesMixin} from '@/components/mixins'
import BottomNav from '@/components/Application/BottomNav'
import MessageBox from '@/components/Common/MessageBox'
import NextButton from '@/components/Common/NextButton'
import ActionButton from '@/components/Common/ActionButton'
import FileUpload from '@/components/Common/FileUpload'
import ApplicationDocumentSchool from './ApplicationDocumentSchool'
import _ from "lodash";

export default {
  name: 'ApplicationDocuments',

  props: {
    step: Number
  },

  mixins: [RulesMixin],

  components: {
    BottomNav,
    MessageBox,
    NextButton,
    ActionButton,
    FileUpload,
    ApplicationDocumentSchool
  },

  data: () => ({
    application: null,
    fields: ['id', 'step', 'applicationDocuments', 'gugCourses'],
    allCourses: [],
    gugCourses: [],
    showDocuments: false,
    showDeleteGrade: false,
    schoolId: null,
    anotherSchool: false,
  }),

  created() {
    console.log("created")
    this.initApplication()
  },

  watch: {
    selectedApplication: {
      handler: function () {
        console.log("watch selectedApplication")
        this.initApplication()
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication', 'haveEducation']),
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('basic', ['hasProfessionOrientations']),

    nextStepDisabled() {
      return this.haveEducation && !(this.selectedGrades.length || this.selectedFiles.length || this.selectedGUGCerts.length)
    },

    selectedGUGCerts() {
      return filter(this.selectedApplication.applicationDocuments, {applicationDocumentTypeId: 3})
    },

    selectedFiles() {
      return filter(this.selectedApplication.applicationDocuments, {applicationDocumentTypeId: 2})
    },

    selectedGrades() {
      return filter(this.selectedApplication.applicationDocuments, {applicationDocumentTypeId: 1})
    }

  },

  methods: {
    ...mapActions('application', ['updateSelectedApplication']),

    initApplication() {
      console.log("initApplication")
      //- Initialize application with either selected or empty application
      this.fetchCourses()

      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }
      if(this.selectedApplication && (this.selectedApplication.applicationDocuments || []).length){
        this.showDocuments = true
      } else if (this.selectedApplication && this.selectedApplication.showDocuments) {
        this.showDocuments = this.selectedApplication.showDocuments
      }
      if (this.selectedApplication && this.selectedApplication.gugCourses) {
        this.gugCourses = this.selectedApplication.gugCourses
       }
      if(this.selectedApplication && this.selectedApplication.schoolId){
        this.schoolId = this.selectedApplication.schoolId
      }
      if(this.selectedApplication){
        this.anotherSchool = !!this.selectedApplication.anotherSchool
      }
      //- And add defaults
      this.application.step = this.currentStep
    },

    /**
     * @vuese
     * Used to pass to the next step after all the documents are saved
     * @arg The argument is an integer representing application id
     */
    nextStep() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }
      if (
        this.application &&
        this.application.applicationCourses &&
        this.application.applicationCourses.length &&
        !(this.application.applicationDocuments && this.application.applicationDocuments.length)
      ) {
        this.$events.fire('showError', this.$t('application.documents.validationerror'))
        return
      }
      let courses = [];
      this.allCourses.forEach(group => {
        group.forEach(c => {
          courses.push({
                id: c.id,
                applicationId: this.selectedApplication.id,
                courseId: c.id,
                approved: null,
              });
          })
        })

      API.updateApplication(this.application.id, {data: {
        ...this.application,
        schoolId: this.anotherSchool ? null : this.schoolId,
        anotherSchool: !!this.anotherSchool
      }})
        .then(response => {
          this.selectedApplication.showDocuments = this.showDocuments
          this.updateStore()
          this.showDocuments ? this.$emit('goToStep', '+1') : this.$emit('goToStep', '+2')
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
    },

    fetchCourses() {
      console.log("fetchCourses")

      if (this.selectedApplication && this.selectedApplication.professionId > 0) {
        API.listProfessionCourses(this.selectedApplication.professionId)
          .then((response) => {
            this.allCourses = _.values(response.data)
          })
          .catch((error) => {
            console.log("get courses error", error);
          });
      }
    },

    updateStore() {
      API.getApplication(this.selectedApplication.id)
        .then(res => {
          if (res && res.data) {
            this.updateSelectedApplication(res.data)
          }
        })
        .catch(err => {console.log('There was an error 1:', err)})
    }
  }
}
</script>
<style scoped>
.theme--light .v-list.height-small .v-list-item .v-list-item__title {
  font-weight: bold !important;
}
</style>
